<aside [id]="panelId" class="panel-wrapper Auto_Panel {{classes}}" #sidePanel
       [ngClass]="{'opened': displayStatus, 'opened-shifted': displayStatusShifted,  'override-right': position === 'right'}">
  <section class="panel-title Auto_Panel_Title">
    <span class="title-text Auto_Panel_Title_Text">{{title}}</span>
    <span *ngIf="showCloseSideBarIcon" class="icon__cross close-btn Auto_Btn_Close" (click)="closeSidePanel()"></span>
    <span *ngIf="!showCloseSideBarIcon" class="icon__cross close-btn Auto_Btn_Close" (click)="closePanel()"></span>
  </section>
  <section class="panel-content Auto_Panel_Content">
    <span #loadTarget></span>
  </section>
</aside>
